{
  "salon-booking-config-page": {
    "buttons": {
      "book": "ĐẶT"
    },
    "text": {
      "black-listed": "Chức năng đặt lịch trực tuyến của bạn tại salon này đã bị chặn. Vui lòng liên hệ với salon để đặt lịch mới",
      "not-found-available-time": "Nếu không tìm được thời gian mong muốn, vui lòng gọi cho chúng tôi theo số điện thoại"
    }
  }
}
